export default {
  buttons: {
    go_to_basket: 'Mergi la Coș',
  },
};
